import { Injectable } from '@angular/core';
import { WindowRefService } from './window-ref.service';

@Injectable()
export class WhatsappService {
    hostWhatsappDesktop = 'https://web.whatsapp.com/send?phone=';
    hostWhatsappMobile = 'https://wa.me/';
    countryCode = '54';
    link: string;

    constructor(protected windowRef: WindowRefService) { }

    sendWhatsapp(isMobile: boolean, phoneNumber: string, message?: string) {
        message = message || '';
        this.link = '';
        const options = 'toolbar=yes,scrollbars=yes,resizable=yes,top=500,left=500,width=800,height=500';
        const countryCode = (isMobile) ? this.countryCode : `+${this.countryCode}`;
        const phone = `${countryCode}${phoneNumber}`;
        this.link = (isMobile) ? `${this.hostWhatsappMobile}${phone}?text=${message}`
        : `${this.hostWhatsappDesktop}${phone}&text=${message}`;
        this.windowRef.nativeWindow.open(this.link, '_blank', options);
    }
}
